import { useGetAllPurchaseReturnsQuery } from '@/features/slice/purchase-return';
import { useUrlPagination } from '@/hooks';

export const usePurchaseReturnList = () => {
    const { limit, page } = useUrlPagination();
    const { data, isLoading, isFetching, isError, error } =
        useGetAllPurchaseReturnsQuery({
            limit,
            page,
            sort_by: 'created_at',
            sort_order: 'desc',
        });

    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
    };
};
